import { Box, HStack, Spacer } from '@chakra-ui/react';
import {
  BackofficeActivitiesPromos,
  BackofficeOrderPO,
} from '@diamond/shared/types';
import { Badge, DataTable, Divider, Text, TextField } from '@diamond/shared/ui';
import { adminCurrencyFormatter, catalogMasking, LIST_FEATURE_FLAGS, useFeatureFlag } from '@diamond/shared/utils';
import { FieldValues, UseFormRegister } from 'react-hook-form';

import { mergeOrderItemsWithPromos } from '../utils/build-activity-order-items';
import { columns } from './activity-detail-po-columns';

interface ActivitiesDetailPOTablesProps {
  register: UseFormRegister<FieldValues>;
  diamond?: BackofficeOrderPO['orders'][number];
  trading?: BackofficeOrderPO['orders'][number];
  equipment?: BackofficeOrderPO['orders'][number];
  food?: BackofficeOrderPO['orders'][number];
  distributionChannel: string;
}

export function ActivitiesDetailPOTables({
  register,
  diamond,
  trading,
  equipment,
  food,
  distributionChannel,
}: ActivitiesDetailPOTablesProps) {
  const isVoucherMenuEnabled = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_VOUCHERS_MENU,
    false
  );

  const mergeDataPromos = (
    items: BackofficeOrderPO['orders'][0]['items'] | undefined,
    promos: BackofficeActivitiesPromos | null | undefined
  ) => {
    if (!items) {
      return items;
    }

    return mergeOrderItemsWithPromos(items, promos, {
      injectPromoFreeGoods: !isVoucherMenuEnabled,
    });
  };

  return (
    <>
      {diamond && (
        <Box py="2">
          <Box>
            <HStack my="3" spacing="4" direction="row">
              <Box>
                <Text fontSize="xl" fontWeight="bold">
                  Nomor Sub PO SOL : {diamond.sub_po_number} -{' '}
                  <Badge variant="blue" fontSize="md">
                    {catalogMasking(diamond.division, distributionChannel)}
                  </Badge>
                </Text>
              </Box>
              <Spacer />
              <Box>
                <TextField
                  width="25rem"
                  name="total"
                  placeholder={'Total Nilai Order'}
                  register={register}
                  value={`Total Order Per Divisi: ${adminCurrencyFormatter(
                    diamond.subtotal
                  )}`}
                  isDisabled
                  _disabled={{
                    color: 'black',
                  }}
                />
              </Box>
            </HStack>
          </Box>
          <Box pb="5">
            <Divider />
          </Box>
          <DataTable
            columns={columns}
            data={mergeDataPromos(diamond.items, diamond.promos) ?? []}
          />
        </Box>
      )}
      {trading && (
        <Box py="2">
          <Box>
            <HStack my="3" spacing="4" direction="row">
              <Box>
                <Text fontSize="xl" fontWeight="bold">
                  Nomor Sub PO SOL : {trading.sub_po_number} -{' '}
                  <Badge variant="blue" fontSize="md">
                    {catalogMasking(trading.division, distributionChannel)}
                  </Badge>
                </Text>
              </Box>
              <Spacer />
              <Box>
                <TextField
                  width="25rem"
                  name="total"
                  placeholder={'Total Nilai Order'}
                  register={register}
                  value={`Total Order Per Divisi: ${adminCurrencyFormatter(
                    trading.subtotal
                  )}`}
                  isDisabled
                  _disabled={{
                    color: 'black',
                  }}
                />
              </Box>
            </HStack>
          </Box>
          <Box pb="5">
            <Divider />
          </Box>
          <DataTable
            columns={columns}
            data={mergeDataPromos(trading.items, trading.promos) ?? []}
          />
        </Box>
      )}
      {equipment && (
        <Box py="2">
          <Box>
            <HStack my="3" spacing="4" direction="row">
              <Box>
                <Text fontSize="xl" fontWeight="bold">
                  Nomor Sub PO SOL : {equipment.sub_po_number} -{' '}
                  <Badge variant="blue" fontSize="md">
                    {catalogMasking(equipment.division, distributionChannel)}
                  </Badge>
                </Text>
              </Box>
              <Spacer />
              <Box>
                <TextField
                  width="25rem"
                  name="total"
                  placeholder={'Total Nilai Order'}
                  register={register}
                  value={`Total Order Per Divisi: ${adminCurrencyFormatter(
                    equipment.subtotal
                  )}`}
                  isDisabled
                  _disabled={{
                    color: 'black',
                  }}
                />
              </Box>
            </HStack>
          </Box>
          <Box pb="5">
            <Divider />
          </Box>
          <DataTable
            columns={columns}
            data={mergeDataPromos(equipment.items, equipment.promos) ?? []}
          />
        </Box>
      )}
      {food && (
        <Box py="2">
          <Box>
            <HStack my="3" spacing="4" direction="row">
              <Box>
                <Text fontSize="xl" fontWeight="bold">
                  Nomor Sub PO SOL : {food.sub_po_number} -{' '}
                  <Badge variant="blue" fontSize="md">
                    {catalogMasking(food.division, distributionChannel)}
                  </Badge>
                </Text>
              </Box>
              <Spacer />
              <Box>
                <TextField
                  width="25rem"
                  name="total"
                  placeholder={'Total Nilai Order'}
                  register={register}
                  value={`Total Order Per Divisi: ${adminCurrencyFormatter(
                    food.subtotal
                  )}`}
                  isDisabled
                  _disabled={{
                    color: 'black',
                  }}
                />
              </Box>
            </HStack>
          </Box>
          <Box pb="5">
            <Divider />
          </Box>
          <DataTable
            columns={columns}
            data={mergeDataPromos(food.items, food.promos) ?? []}
          />
        </Box>
      )}
    </>
  );
}
